export default "__VITE_ASSET__BIG5RNQ1__"